<script setup lang="ts">
import privacyHtml from '~/data/pages/privacy.html?raw'

useSchemaOrg([
  defineBreadcrumb({
    itemListElement: [
      { name: 'Home', item: '/' },
      { name: 'Privacy Policy', item: '/privacy' }
    ]
  })
])

useHead({
  title: 'Genius Link Services Privacy Policy',
  meta: [
    { name: 'description', content: 'Check out full details on the Genius Link Privacy Policy. Our goal is to keep your information secure, and help you understand how we use your data.' }
  ]
})
</script>

<template>
  <div class="container">
    <section class="row">
        <div class="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
            <ol class="breadcrumb">
                <li><NuxtLink to="/">Home</NuxtLink></li>
                <li class="active">Privacy Policy</li>
            </ol>
            <h1>GeoRiot Privacy Policy</h1>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="privacyHtml"></div>
        </div>
    </section>
  </div>
</template>
